import { useFirestoreID } from '../../firebase/useFirestore'

/**
 * Toont de titel van het onderzoek dat bij een ID hoort.
 *
 * @param {object} props
 * @param {string} props.item - ID van het onderzoek (het veld `ID`, niet `docid`)
 */
const ResearchMeta = ({item}) => {

  const research = useFirestoreID('Research', item ? item : '')

  return (
    <>
        {research && research.map((researchItem) => (
            <p key={researchItem.ID}>{researchItem.Title}</p>
        ))}
    </>
  )
}

export default ResearchMeta
